// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__bVjpI","noBorder":"Separator_noBorder__1tEPJ","noMargin":"Separator_noMargin__3RMAB"};